import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  FormControl,
  TextField,
  Paper,
  Checkbox,
  Button,
  IconButton,
  Tooltip,
  Stack,
  useTheme,
  LinearProgress,
  Select,
  MenuItem,
  InputLabel,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControlLabel,
  Chip
} from "@mui/material";
import {
  dataGridHeaderFooterHeight,
  dataGridHeight,
  dataGridRowHeight,
  formGap,
} from "../../../ui-components/global/utils";
import {
  explorePostData,
  fetchApidata,
  postApidata,
  postApidatawol,
  getDeployment,
  postDeployment,
  invoiceExploreGetData,
  postData,
  resetTrackingData,
  empAttendance,
  Attendance,
  AttendanceProcess,
  AttendanceEntryPost,
  // AttendanceEntryGet,
} from "../../../store/reducers/Formapireducer";
import useMediaQuery from "@mui/material/useMediaQuery";
import { CheckinAutocomplete, MultiFormikOptimizedAutocomplete, Productautocomplete } from "../../../ui-components/global/Autocomplete";
import {
  GridToolbarContainer,
  GridActionsCellItem,
  DataGrid,
  GridRowModes,
  GridRowEditStopReasons,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Cancel";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { Formik } from "formik";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import { useProSidebar } from "react-pro-sidebar";
import ListAltOutlinedIcon from "@mui/icons-material/ListAltOutlined";

import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import ResetTvIcon from "@mui/icons-material/ResetTv";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import { tokens } from "../../../Theme";
import store from "../../../index";
import { LoadingButton } from "@mui/lab";
import { useDispatch } from "react-redux";
import {
  AttendanceEntryGet,
  fetchExplorelitview,
} from "../../../store/reducers/Explorelitviewapireducer";
import { PDFDownloadLink } from "@react-pdf/renderer";
import AttendanceHistoryPDF from "../../reports/AttendanceHistoryPdf";
import { toast } from "react-hot-toast";
import { Employeeautocomplete } from "../../../ui-components/global/Autocomplete";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { nanoid } from "@reduxjs/toolkit";
import ScheduleIcon from "@mui/icons-material/Schedule";
const EditAttendanceEntry = () => {
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const navigate = useNavigate();
  const params = useParams();
  const location = useLocation();
  const mode = params.Mode;
  const dispatch = useDispatch();
  const isManager = sessionStorage.getItem("isManager");
  // const listViewurl = useSelector((state) => state.globalurl.listViewurl);
  var recID = params.id;
  var accessID = params.accessID;
  const listViewurl = useSelector((state) => state.globalurl.listViewurl);
  const { toggleSidebar, broken, rtl } = useProSidebar();
  const deploymentData = useSelector((state) => state.formApi.deploymentData);
  const exploreLoading = useSelector((state) => state.exploreApi.loading);
  const isLoading = useSelector((state) => state.formApi.postLoading);
  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(0);
  const [rowCount, setRowCount] = useState(0);
  const [show, setScreen] = React.useState("0");

  //FOR OVERALL PRESENT CHECKBOX
  const [selectAllPresent, setSelectAllPresent] = useState(false);
  const EMPID = sessionStorage.getItem("EmpId");
  console.log(EMPID, "--EMPID");
  const companyID = sessionStorage.getItem("companyId");
  const SubscriptionCode = sessionStorage.getItem("SubscriptionCode");
  const is003Subscription = SubscriptionCode.endsWith("003");
    const sliceSubscriptionCode = SubscriptionCode.slice(-3);

  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  var compID = sessionStorage.getItem("companyId");
  const [errorMsgData, setErrorMsgData] = useState(null);

    const ClassificationRecID = sessionStorage.getItem("ClassificationRecID");
  const ClassificationData = JSON.parse(
    sessionStorage.getItem("ClassificationData") || "[]"
  );

  console.log(ClassificationData, "--find getItem ClassificationData");

  const filteredClassification = ClassificationData.filter(
    (item) => item.CfcName !== "Student"
  );
  const classificationIDs = filteredClassification.map(
    (item) => item.CfcID
  );

  const classificationIDString = classificationIDs
    .map((id) => `'${id}'`)
    .join(",");


    //TeacherID Filter Passing
// const MangerEmpDetails = sessionStorage.getItem("MangerEmpDetails" || "[]");
 const MangerEmpDetails = JSON.parse(
    sessionStorage.getItem("MangerEmpDetails") || "[]"
  );
  console.log(MangerEmpDetails, "--MangerEmpDetails");
  
 const mgrEMPIDs = MangerEmpDetails.map(
    (item) => item.ID
  );

  const mgrEMPIDString = mgrEMPIDs
    .map((id) => `'${id}'`)
    .join(",");
    console.log(mgrEMPIDString, "--find mgrEMPIDString");
    

  // useEffect(() => {
  //    dispatch(getDeployment({HeaderID: "",}));
  //   }, []);
  useEffect(() => {
    fetch(process.env.PUBLIC_URL + "/validationcms.json")
      .then((res) => {
        if (!res.ok) throw new Error("Failed to fetch validationcms.json");
        return res.json();
      })
      .then((data) => {
        setErrorMsgData(data);
      })
      .catch((err) => console.error("Error loading validationcms.json:", err));
  }, []);

  //get rowsdata
  // const AttendanceEntryrow = useSelector(
  //   (state) => state.formApi.AttendanceEntryrow
  // );
  // console.log("AttendanceEntryrow", AttendanceEntryrow);

  //post data
  const data = useSelector((state) => state.formApi.Data);
  console.log(data, "--data");

  const today = new Date().toISOString().split("T")[0];
  const [selectedDate, setSelectedDate] = useState(today);
  const [selectedPro, setSelectedPro] = useState([]);

  const formatDateToDDMMYYYY = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months start from 0
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };
  const [rows, setRows] = React.useState([]);

  // const handleApplyClick = (values) => {
  //   dispatch(AttendanceEntryGet({
  //     ManagerID: EMPID,
  //     Checkindate: formatDateToDDMMYYYY(selectedDate),
  //     CompanyID: companyID
  //   }));
  // };


  const handleApplyClick = async (values) => {

    const projecID = selectedPro
      ?.map((proj) => proj.RecordID)
      .join(",");

    console.log("PROJECT ID:", projecID);

    try {
      const resultAction = await dispatch(
        AttendanceEntryGet({
          ManagerID: EMPID,
          // ProjectID: projecID,
          ProjectID: values?.ProName?.RecordID,
          Checkindate: formatDateToDDMMYYYY(selectedDate),
          CompanyID: companyID,
        })
      );

      const payload = resultAction?.payload;

      if (payload?.Status === "Y" && Array.isArray(payload?.Data)) {
        const resData = payload.Data.map((value, index) => ({
          ...value,
          SLNO: index + 1,
        }));

        setRows(resData);

        // ✅ set header checkbox immediately
        const allSelected = resData.every(
          (row) => Number(row.Present) === 1
        );
        setSelectAllPresent(allSelected);
      } else {
        setRows([]);
      }
    } catch (error) {
      console.error("Error while applying attendance entry:", error);
      setRows([]);
    }
  };


  //post
  const handleSaveButtonClick = async () => {
    // const formattedData = rows.map((row) => ({
    //   EmpID: row.EmpID,
    //   EntryDate: selectedDate,
    //   Present: row.Present === 1 ? "Y" : "N",
    //   Remarks: row.Remarks || "",
    //   ManagerID: EMPID,
    //   // ShiftCheck: row.ShiftCheck ? "Y" : "N",
    //   ShiftFromTime:row.ShiftFromTime,
    //   ShiftToTime: row.ShiftToTime,
    //   ProjectID: row.ProjectID || ""
    //   // Fromtime: shiftPopupData.ShiftStartTime,
    //   // Totime: shiftPopupData.ShiftEndTime,
    // }));
    const formattedData = rows.map((row) => {
      const isShiftAdjusted = row.ShiftCheck === "Y";

      return {
        EmpID: row.EmpID,
        EntryDate: selectedDate,
        // Present: row.Present === 1 ? "Y" : "N",
        Present: Number(row.Present) === 1 ? "Y" : "N",
        Remarks: row.Remarks || "",
        ManagerID: EMPID,
        ProjectID: row.ProjectID || "",
        CompanyID: companyID,
        ShiftFromTime: isShiftAdjusted
          ? row.ShiftFromTime
          : row.ShiftStartTime,

        ShiftToTime: isShiftAdjusted
          ? row.ShiftToTime
          : row.ShiftEndTime,
      };
    });

    try {
      const response = await dispatch(
        AttendanceEntryPost({ AttendanceEntry: formattedData })
      );
      console.log(response, "--response");

      // if (response.payload.Status.Status === "Y") {
      if (response.payload.Status === "Y") {
        toast.success(response.payload.Msg);
        toast.success(response.payload.MailMsg);
        navigate("/Apps/EditAttendanceEntry");
        setRows([]);
        dispatch(resetTrackingData());
        setSelectAllPresent(false);
      } else if (response.payload.Status === "N") {
        toast.error(response.payload.Msg);
      } else {
        toast.error(response.payload.Msg || "Failed to save data.");
      }
    } catch (error) {
      console.error("Dispatch error:", error);
      toast.error("Something went wrong while saving.");
    }
  };

  const [rowModesModel, setRowModesModel] = React.useState({});

  const handleRowEditStop = (params, event) => {
    // if (params.reason === GridRowEditStopReasons.rowFocusOut) {
    event.defaultMuiPrevented = true;
    // }
  };

  const handleEditClick = (EmpID) => () => {
    console.log("--calling Editclick");
    // Force DataGrid to re-evaluate editable state
    // setRowModesModel((prevModel) => ({
    //   ...prevModel,
    //   [updatedRow.EmpID]: { mode: GridRowModes.Edit },
    // }));
    setRowModesModel({
      ...rowModesModel,
      [EmpID]: { mode: GridRowModes.Edit },
    });
  };

  // const handleSaveClick = (EmpID) => () => {
  //   setRowModesModel({
  //     ...rowModesModel,
  //     [EmpID]: { mode: GridRowModes.View },
  //   });
  // };

  // const handleDeleteClick = (RecordID) => async () => {
  //   setRows(rows.filter((row) => row.RecordID !== RecordID));

  //   if (!isNaN(RecordID)) {
  //     const idata = {
  //       //RecordID: recID,
  //       RecordID: RecordID,
  //     };

  //     const response = await dispatch(
  //       postData({
  //         accessID: "TR237",
  //         action: "harddelete",
  //         idata: idata,
  //       })
  //     );

  //     if (response.payload?.Status === "Y") {
  //       toast.success(response.payload.Msg);
  //       const data = await dispatch(
  //         getTaskDetailListviewData({
  //           accessID: "TR237",
  //           screenName: "Task Detail",
  //           filter: `TaskID = ${recID}`,
  //           any: "",
  //           CompID: "",
  //         })
  //       );
  //       console.log("🚀 ~ screenChange ~ data:", data);
  //       if (data.payload.Status == "Y") {
  //         const resData = data.payload.Data.rows.map((value) => {
  //           return {
  //             ...value,
  //             TaskDetailRoleID: {
  //               RecordID: value.TaskDetailRoleID,
  //               Name: value.RoleName,
  //             },
  //           };
  //         });
  //         setRows(resData);
  //       } else {
  //         setRows([]); // Ensures rows don't break if explorelistViewData is undefined or not an array
  //       }
  //     } else {
  //       toast.error(response.payload?.Msg || "Operation failed");
  //     }
  //   }
  // };

  // const handleCancelClick = (RecordID) => () => {
  //   setRowModesModel({
  //     ...rowModesModel,
  //     [RecordID]: { mode: GridRowModes.View, ignoreModifications: true },
  //   });

  //   const editedRow = rows.find((row) => row.RecordID === RecordID);
  //   if (editedRow.isNew) {
  //     setRows(rows.filter((row) => row.RecordID !== RecordID));
  //   }
  // };

  const processRowUpdate = (newRow, oldRow) => {
    const { EmpID, EmpName, Remarks, Present, SLNO } = newRow;

    // Validation rules
    // if (!TaskDetailRoleID) {
    //   throw new Error("Role ID is required.");
    // }

    // if (!TaskDetailUnit || TaskDetailUnit.trim() === "") {
    //   throw new Error("Unit is required.");
    // }

    // if (!ProjectPlanedDate || ProjectPlanedDate.trim() === "") {
    //   throw new Error("Planned Date is required.");
    // }

    // if (isNaN(TaskDetailEffort) || TaskDetailEffort <= 0) {
    //   throw new Error("Effort must be a number greater than 0.");
    // }

    // If all validations pass
    const updatedRow = { ...newRow, isNew: false };

    setRows((prevRows) =>
      prevRows.map((row) => (row.EmpID === newRow.EmpID ? updatedRow : row))
    );
    console.log(updatedRow, "--processRowUpdate updatedRow");

    return updatedRow;
  };

  const handleRowModesModelChange = (newRowModesModel) => {
    setRowModesModel(newRowModesModel);
  };


  const handleSelectAllPresent = (checked) => {
    setSelectAllPresent(checked);

    setRows((prevRows) =>
      prevRows.map((row) => ({
        ...row,
        Present: checked ? 1 : 0,
        ShiftCheck: checked ? row.ShiftCheck : "N",
        shiftChecked: checked ? row.shiftChecked : false,
        ShiftFromTime: checked ? row.ShiftFromTime : "",
        ShiftToTime: checked ? row.ShiftToTime : "",
      }))
    );
  };

  function AttendanceTool(props) {
    const { setRows, setRowModesModel } = props;
    const handleClick = () => {
      const id = nanoid();
      const nextSLNO =
        rows.length > 0 ? Math.max(...rows.map((row) => row.SLNO || 0)) + 1 : 1;
      setRows((oldRows) => [
        ...oldRows,
        {
          RecordID: id, // Temporary ID, replaced after backend save
          SLNO: nextSLNO,
          TaskID: "",
          TaskDetailRoleID: "",
          RoleCode: "",
          RoleName: "",
          TaskDetailEffort: 0,
          TaskDetailUnit: "",
          ProjectPlanedDate: "",
          isNew: true,
        },
      ]);
      setRowModesModel((oldModel) => ({
        ...oldModel,
        [id]: { mode: GridRowModes.Edit, fieldToFocus: "TaskDetailRoleID" },
      }));
    };
    return (
      <GridToolbarContainer
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "row" }}>
          <Typography>Attendance</Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <GridToolbarQuickFilter />
        </Box>
      </GridToolbarContainer>
    );
  }

  // const handlePresentCheckboxChange = (updatedRow) => {
  //   setRows((prevRows) =>
  //     prevRows.map((row) => (row.EmpID === updatedRow.EmpID ? updatedRow : row))
  //   );
  // };
  const handlePresentCheckboxChange = (updatedRow) => {
    const isPresent = Number(updatedRow.Present) === 1;

    setRows((prevRows) =>
      prevRows.map((row) =>
        row.EmpID === updatedRow.EmpID
          ? {
            ...row,
            ...updatedRow,

            // If Present becomes 0 → reset shift fields
            shiftChecked: isPresent ? row.shiftChecked : false,
            ShiftCheck: isPresent ? row.ShiftCheck : "N",
            // ShiftFromTime: isPresent ? row.ShiftFromTime : "",
            // ShiftToTime: isPresent ? row.ShiftToTime : "",
            Present: updatedRow.Present,
            ShiftFromTime: updatedRow.ShiftFromTime,
            ShiftToTime: updatedRow.ShiftToTime,
            Fromtime: isPresent ? row.Fromtime : "",
            Totime: isPresent ? row.Totime : "",
          }
          : row
      )
    );
  };

  const [shiftList, setShiftList] = useState([]);
  const [openShiftPopup, setOpenShiftPopup] = useState(false);
  const [shiftPopupData, setShiftPopupData] = useState({
    empID: "",
    ShiftID: "",
    ShiftName: "",
    ShiftStartTime: "",
    ShiftEndTime: "",
    Monday: false,
    Tuesday: false,
    Wednesday: false,
    Thursday: false,
    Friday: false,
    Saturday: false,
    Sunday: false,
    DesignationID: "",
    LocationID: "",
    StoregatemasterID: "",
    DefaultProject: "",
    ProjectCode: "",
    ProjectName: "",
    DefaultFunction: "",
    FunctionCode: "",
    FunctionName: "",
    Horizontal: false,
    Vertical: false,
    HorizontalMimNo: "",
    VerticalMimNo: "",
  });

  //  const idata = {
  //       HeaderID: recID,     
  //       CheckInTime: values.shift?.ShiftStartTime || "",
  //       CheckOutTime: values.shift?.ShiftendTime || "",
  //       Monday: values.Monday === true ? "Y" : "N",
  //       Tuesday: values.Tuesday === true ? "Y" : "N",
  //       Wednesday: values.Wednesday === true ? "Y" : "N",
  //       Thursday: values.Thursday === true ? "Y" : "N",
  //       Friday: values.Friday === true ? "Y" : "N",
  //       Saturday: values.Saturday === true ? "Y" : "N",
  //       Sunday: values.Sunday === true ? "Y" : "N",     
  //       DesignationID: values.manager.RecordID || 0,
  //       LocationID: values.location.RecordID || 0,
  //       StoregatemasterID: values.gate.RecordID || 0,
  //       DefaultProject: values.project.RecordID || 0,
  //       ProjectCode: values.project.Code || "",
  //       ProjectName: values.project.Name || "",
  //       DefaultFunction: values.function.RecordID || 0,
  //       FunctionCode: values.function.Code || "",
  //       FunctionName: values.function.Name || "",
  //       ShiftID: values.shift.RecordID || 0,
  //       ShiftCode: values.shift.Code || "",
  //       ShiftName: values.shift.Name || "",
  //       BioMetric: values.biometric === true ? "Y" : "N",
  //       ManagerManual: values.managermanual === true ? "Y" : "N",
  //       CloudApplication: values.cloud === true ? "Y" : "N",
  //       MobileGeoFencing: values.mobile === true ? "Y" : "N",
  //     }; 

  const AttColumn = [
    {
      field: "slno",
      headerName: "SL#",
      width: 60,
      sortable: false,
      filterable: false,
      headerAlign: "center",
      disableColumnMenu: true,
      valueGetter: (params) => {
        const index = params.api.getRowIndexRelativeToVisibleRows(params.id);

        const totalVisibleRows = params.api.getAllRowIds().length;
        const totalAllRows = params.api.getRowsCount();

        if (totalVisibleRows < totalAllRows) {
          return index + 1;
        } else {
          return page * pageSize + index + 1;
        }
      },
    },
    {
      headerName: "Employee ID",
      field: "EmpID",
      width: 100,
      align: "left",
      headerAlign: "center",
      hide: true,
    },
    {
      headerName: "Project ID",
      field: "ProjectID",
      width: 100,
      align: "left",
      headerAlign: "center",
      hide: true,
    },
    {
      field: "EmpName",
      headerName: "Personnel",
      headerAlign: "center",
      width: 150,
    },
    {
      field: "Department",
      headerName: "Department",
      headerAlign: "center",
      width: 150,
    },
    {
      field: "Present",
      headerName: "Present",
      width: 100,
      sortable: false,
      headerAlign: "center",
      editable: false,
      renderHeader: () => (
        <Box display="flex" alignItems="center" justifyContent="center" gap={0.5}>
          <Checkbox
            checked={selectAllPresent}
            indeterminate={
              rows.some((r) => Number(r.Present) === 1) &&
              !rows.every((r) => Number(r.Present) === 1)
            }
            onChange={(e) => handleSelectAllPresent(e.target.checked)}
            size="small"
          />
          <Typography variant="body2">Present</Typography>
        </Box>
      ),
      renderCell: (params) => (
        <Checkbox
          checked={Boolean(Number(params.row.Present))}
          onChange={(e) => {
            const isChecked = e.target.checked;

            // Open popup only when checked
            if (isChecked) {
              setShiftPopupData({
                SLNO: params.row.SLNO,
                ShiftStartTime: params.row.ShiftStartTime,
                ShiftEndTime: params.row.ShiftEndTime,
                shiftChecked: params.row.shiftChecked || false,
              });
            }

            //  Update Present and reset ShiftCheck when unchecked
            setRows((prevRows) =>
              prevRows.map((r) =>
                r.SLNO === params.row.SLNO
                  ? {
                    ...r,
                    Present: isChecked ? 1 : 0,
                    ShiftCheck: isChecked ? r.ShiftCheck : "N",
                    shiftChecked: isChecked ? r.shiftChecked : false,
                    ShiftFromTime: isChecked ? r.ShiftFromTime : "",
                    ShiftToTime: isChecked ? r.ShiftToTime : "",
                  }
                  : r
              )
            );
          }}
          color="primary"
        />
      ),
    },

    // {
    //   field: "Present",
    //   headerName: "Present",
    //   width: 80,
    //   sortable: false,
    //   headerAlign: "center",
    //   editable: false,
    //   renderCell: (params) => (
    //     <Checkbox
    //       checked={Boolean(Number(params.row.Present))}
    //       onChange={(e) => {
    //         const isChecked = e.target.checked;

    //         // Open popup with row-specific data
    //         setShiftPopupData({
    //           SLNO: params.row.SLNO, // use unique SLNO
    //           ShiftStartTime: params.row.ShiftStartTime,
    //           ShiftEndTime: params.row.ShiftEndTime,
    //           shiftChecked: params.row.shiftChecked || false,
    //         });

    //         // Update Present for **only this row**
    //         setRows((prevRows) =>
    //           prevRows.map((r) =>
    //             r.SLNO === params.row.SLNO
    //               ? { ...r, Present: isChecked ? 1 : 0 }
    //               : r
    //           )
    //         );
    //       }}
    //       color="primary"
    //     />
    //   )

    // },

    {
      field: "shift",
      headerName: "Shift",
      width: 100,
      sortable: false,
      headerAlign: "center",
      align: "center",
      editable: false,
      // renderCell: (params) => (

      //   <IconButton
      //     color="primary"
      //     sx={{ alignItems: "center" }}
      //     disabled={Number(params.row.Present) !== 1}
      //     onClick={() => setOpenShiftPopup(true)}
      //   >
      //     <ScheduleIcon />
      //   </IconButton>

      // )
      renderCell: (params) => (
        <IconButton
          color="primary"
          disabled={Number(params.row.Present) !== 1}
          onClick={() => {
            setShiftPopupData({
              SLNO: params.row.SLNO,
              ShiftStartTime: params.row.shiftChecked
                ? params.row.ShiftFromTime
                : params.row.ShiftStartTime,
              ShiftEndTime: params.row.shiftChecked
                ? params.row.ShiftToTime
                : params.row.ShiftEndTime,
            });
            setOpenShiftPopup(true);
          }}
        >
          <ScheduleIcon />
        </IconButton>
      )

    },
    {
      field: "ShiftName",
      headerName: "Shift Name",
      headerAlign: "center",
      width: 150,
    },
    // {
    //   field: "Fromtime",
    //   headerName: "From Time",
    //   width: 150,
    //   headerAlign: "center",
    //   renderCell: (params) => (
    //     <>
    //       {params.row.Present == 1 || params.row.shiftChecked
    //         ? params.row.ShiftFromTime
    //         : "---"}
    //     </>
    //   ),
    // },
    // {
    //   field: "Totime",
    //   headerName: "To Time",
    //   width: 100,
    //   headerAlign: "center",
    //   renderCell: (params) => (
    //     <>
    //       {params.row.Present == 1 || params.row.shiftChecked
    //         ? params.row.ShiftToTime
    //         : "---"}
    //     </>
    //   ),
    // },
    {
      field: "ShiftStartTime",
      headerName: "From Time",
      width: 150,
      headerAlign: "center",
      renderCell: (params) => (
        <>
          {params.row.shiftChecked ? params.row.ShiftFromTime : params.row.ShiftStartTime}
        </>
      ),
    },

    {
      field: "ShiftEndTime",
      headerName: "To Time",
      width: 100,
      headerAlign: "center",
      renderCell: (params) => (
        <>
          {params.row.shiftChecked ? params.row.ShiftToTime : params.row.ShiftEndTime}
        </>
      ),
    },

    {
      field: "Remarks",
      headerName: "Remarks",
      headerAlign: "center",
      width: 680,
      editable: true,
    },


  ];

  const entrows = [
    {
      SLNO: 1,
      Name: "John Doe",
      Present: "Yes",
      Remarks: "Attended all meetings",
    },
    {
      SLNO: 2,
      Name: "Jane Smith",
      Present: "No",
      Remarks: "On leave",
    },
  ];
  /***********Attendance ************/

  // const currentMonthNumber = new Date().getMonth() + 1;
  // const currentYear = new Date().getFullYear();
  const AttInitialvalues = {
    fromDate: today,
    // description: data.Name,
    // Sal: data.Sal,
    // month: currentMonthNumber,
    // year: currentYear,
  };
  const attendaceFnSave = async (values) => {
    const data = {
      Month: values.month.toString(),
      Year: values.year,
      ManagerID: EMPID,
      EmployeeID: EMPID,
      Etype: "E",
    };

    dispatch(empAttendance({ data }));
  };

  const attendaceProcessFnSave = async (values) => {
    // toast.success("----response.payload.Msg");

    console.log("month", values.month.toString());

    const data = {
      Month: values.month.toString(),
      Year: values.year,
      EmployeeID: recID,
    };

    const response = await dispatch(AttendanceProcess({ data }));
    if (response.payload.Status == "Y") {
      toast.success(response.payload.Msg);
      navigate("/Apps/TR217/EditAttendance");
    } else {
      toast.error(response.payload.Msg);
    }
  };

  // const explorelistViewData = useSelector(
  //   (state) => state.exploreApi.explorerowData
  // );
  // const explorelistViewColumn = useSelector(
  //   (state) => state.exploreApi.explorecolumnData
  // );
  const screenChange = (event) => {
    setScreen(event.target.value);
  };
  // const VISIBLE_FIELDS = [
  //   "SLNO",
  //   "OtDate",
  //   "NumberOfHours",
  //   "Status",
  //   "action",
  // ];
  const [funMode, setFunMode] = useState("A");
  // const columns = React.useMemo(
  //   () =>
  //     explorelistViewColumn
  //       ? explorelistViewColumn.filter((column) =>
  //           VISIBLE_FIELDS.includes(column.field)
  //         )
  //       : [],
  //   [explorelistViewColumn]
  // );

  const fnLogOut = (props) => {
    Swal.fire({
      title: errorMsgData.Warningmsg[props],
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: props,
    }).then((result) => {
      if (result.isConfirmed) {
        if (props === "Logout") navigate("/");
        if (props === "Close") navigate("/Apps/Chart");
      }
    });
  };
  const [empData, setempData] = useState(null);
  const handleSelectionEmployeeChange = (newValue) => {
    if (newValue) {
      setempData(newValue);
      console.log(newValue.RecordID, "--selectedproductid");
    } else {
      setempData(null);
    }
  };
  return (
    <React.Fragment>
      {/* {getLoading && <LinearProgress />} */}
      <Paper elevation={3} sx={{ margin: "0px 10px", background: "#F2F0F0", height: "40px" }}>
        <Box display="flex" justifyContent="space-between">
          <Box display="flex" borderRadius="3px" alignItems="center">
            {broken && !rtl && (
              <IconButton onClick={() => toggleSidebar()}>
                <MenuOutlinedIcon />
              </IconButton>
            )}
            <Typography variant="h3" sx={{ marginLeft: "10px", fontSize: "19px", color:"#0000D1"}}>Attendance Entry</Typography>
          </Box>
          <Box display="flex">
            {/* <Tooltip title="Attendance ">
            <IconButton
              onClick={() => navigate("/Apps/TR217/Attendance")}
              color="primary"
            >
              <ListAltOutlinedIcon />
            </IconButton>
          </Tooltip> */}
            <Tooltip title="Close">
              <IconButton onClick={() => fnLogOut("Close")} color="error">
                <ResetTvIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Logout">
              <IconButton color="error" onClick={() => fnLogOut("Logout")}>
                <LogoutOutlinedIcon />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>
      </Paper>

      <Paper elevation={3} sx={{ margin: "10px" }}>
        {/* <Box m="10px"> */}
        <Formik
          initialValues={AttInitialvalues}
          enableReinitialize={true}
          onSubmit={(values, { resetForm }) => {
            setTimeout(() => {
              attendaceFnSave(values, resetForm);
            }, 100);
          }}
        >
          {({
            errors,
            touched,
            handleBlur,
            handleChange,
            isSubmitting,
            values,
            handleSubmit,
            resetForm,
            setFieldValue
          }) => (
            <form
              onSubmit={handleSubmit}
              onReset={() => {
                resetForm();
                dispatch(resetTrackingData());
              }}
            >
              <Box
                display="grid"
                gridTemplateColumns="repeat(2 , minMax(0,1fr))"
                // gap="70px"
                gap={formGap}
                padding={1}
                sx={{
                  "& > div": {
                    gridColumn: isNonMobile ? undefined : "span 4",
                  },
                }}
              >
                <Stack direction="row" spacing={2}>
                  {/* <TextField
                      fullWidth
                      variant="standard"
                      type="text"
                      id="month"
                      name="month"
                      label="Month"
                      value={values.month}
                      focused
                      onChange={handleChange}
                      onBlur={handleBlur}
                      select
                      sx={{
                        "& .MuiFilledInput-root": {
                          backgroundColor: "transparent", // optional: adjust if needed
                        },
                        width:200
                      }}
                    >
                      <MenuItem value={"1"}>January</MenuItem>
                      <MenuItem value={"2"}>February</MenuItem>
                      <MenuItem value={"3"}>March</MenuItem>
                      <MenuItem value={"4"}>April</MenuItem>
                      <MenuItem value={"5"}>May</MenuItem>
                      <MenuItem value={"6"}>June</MenuItem>
                      <MenuItem value={"7"}>July</MenuItem>
                      <MenuItem value={"8"}>August</MenuItem>
                      <MenuItem value={"9"}>September</MenuItem>
                      <MenuItem value={"10"}>October</MenuItem>
                      <MenuItem value={"11"}>November</MenuItem>
                      <MenuItem value={"12"}>December</MenuItem>
                    </TextField>
                  
                    <TextField
                      fullWidth
                      variant="standard"
                      type="number"
                      id="year"
                      name="year"
                      label="Year"
                      value={values.year}
                      inputProps={{ min: "1900", max: "2100", step: "1" }}
                      focused
                      onChange={handleChange}
                      onBlur={handleBlur}
                      sx={{
                        "& .MuiFilledInput-root": {
                          backgroundColor: "transparent",
                           // optional
                        },
                        width:200
                      }}
                    /> */}
                  {/* <TextField
                    name="fromDate"
                    type="date"
                    label="Date"
                    variant="outlined"
                    focused
                    value={values.fromDate}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    sx={{ minWidth: 200 }}
                  /> */}
                  <TextField
                    name="fromDate"
                    type="date"
                    label="Date"
                    variant="outlined"
                    focused
                    value={selectedDate} // ✅ controlled by state
                    onChange={(e) => {
                      const newDate = e.target.value;   // <-- Always use event value
                      setSelectedDate(newDate);
                      setRows((prev) =>
                        prev.map((r) => ({
                          ...r,
                          Present: 0,
                          ShiftFromTime: "",
                          ShiftToTime: "",
                          shiftChecked: false,
                        }))
                      );
                      // dispatch(
                      //   AttendanceEntryGet({
                      //     ManagerID: EMPID,
                      //     Checkindate: formatDateToDDMMYYYY(newDate),
                      //     CompanyID: companyID,

                      //   })
                      // );

                    }}
                    sx={{ minWidth: 200 }}
                    InputLabelProps={{ shrink: true }}
                  />
                  {/* <MultiFormikOptimizedAutocomplete
                    sx={{ width: 250 }}
                    name="ProName"
                    label="Project"
                    id="ProName"
                    value={selectedPro}
                    onChange={(e, newValue) => {
                      setFieldValue("ProName", newValue);
                      setSelectedPro(newValue);
                    }}
                    url={`${listViewurl}?data=${encodeURIComponent(
                      JSON.stringify({
                        Query: {
                          AccessID: "2114",
                          ScreenName: "Project",
                          Filter: `parentID=${compID} AND EmployeeID=${EMPID}`,
                          Any: "",
                        },
                      })
                    )}`}
                  /> */}
                  <CheckinAutocomplete
                    sx={{ width: 250 }}
                    name="ProName"
                    // label="Project"
                    label={is003Subscription ? "Standard/Activities" : "Project"}
                    id="ProName"
                    value={values.ProName}
                    onChange={(newValue) => {
                      setFieldValue("ProName", newValue);
                    }}
                    url={`${listViewurl}?data=${encodeURIComponent(
                      JSON.stringify({
                        Query: {
                          // AccessID: "2114",
                          AccessID:"2185",
                          ScreenName: "Project",
                          Filter: `parentID=${compID} AND EmployeeID=${EMPID}`,
                          Any: "",
                        },
                      })
                    )}`}
                  />
{/* {is003Subscription && (
   <CheckinAutocomplete
                    sx={{ width: 200 }}
                    name="slot"
                    label="Slot"
                    id="slot"
                    value={values.slot}
                    onChange={(newValue) => {
                      setFieldValue("slot", newValue);
                    }}
                    url={`${listViewurl}?data=${encodeURIComponent(
                      JSON.stringify({
                        Query: {
                          AccessID: "2176",
                          ScreenName: "Slot",
                          Filter: `CompanyID='${compID}' AND TeacherID='${EMPID}'`,
                           VerticalLicense: is003Subscription ? sliceSubscriptionCode : "",
                          Any: "",
                        },
                      })
                    )}`}
                  />
)}

 {is003Subscription && (
           <CheckinAutocomplete
                    sx={{ width: 200 }}
                    name="term"
                    label="Term"
                    id="term"
                    value={values.term}
                    onChange={(newValue) => {
                      setFieldValue("term", newValue);
                    }}
                    url={`${listViewurl}?data=${encodeURIComponent(
                      JSON.stringify({
                        Query: {
                          AccessID: "2177",
                          ScreenName: "Term",
                          Filter: `CompanyID='${compID}' AND TeacherID='${EMPID}'`,
                          VerticalLicense: is003Subscription ? sliceSubscriptionCode : "",
                          Any: "",
                        },
                      })
                    )}`}
                  />
                  )}  */}
                  
                </Stack>
                <Stack
                  direction="row"
                  spacing={2}
                  display="flex"
                  padding={1}
                  justifyContent="end"
                >
                  <Button
                    variant="contained"
                    color="secondary"
                    type="submit"
                    onClick={(e) => {
                      // e.preventDefault(); // ✅ Add this
                      handleApplyClick(values);
                    }}
                  >
                    APPLY
                  </Button>
                  {/* <Button
                    onClick={() => attendaceProcessFnSave(values)}
                    type="reset"
                    variant="contained"
                    color="primary"
                  >
                    PROCESS
                  </Button> */}
                  <Button
                    type="reset"
                    variant="contained"
                    color="error"
                    size="small"
                  >
                    RESET
                  </Button>

                </Stack>
              </Box>

              <Box sx={{ gridColumn: "span 4" }}>
                <Box
                  height="420px"
                  margin={1}
                  // height={dataGridHeight}
                  //  marginTop={2}
                  sx={{
                    "& .MuiDataGrid-root": {
                      // border: "none",
                    },
                    "& .MuiDataGrid-cell": {
                      // borderBottom: "none",
                    },
                    "& .name-column--cell": {
                      color: colors.greenAccent[300],
                    },
                    "& .MuiDataGrid-columnHeaders": {
                      backgroundColor: colors.blueAccent[800],
                      // borderBottom: "none",
                    },
                    "& .MuiDataGrid-virtualScroller": {
                      backgroundColor: colors.primary[400],
                    },
                    "& .MuiDataGrid-footerContainer": {
                      // borderTop: "none",
                      backgroundColor: colors.blueAccent[800],
                    },
                    "& .MuiCheckbox-root": {
                      color: `${colors.greenAccent[200]} !important`,
                    },
                    "& .odd-row": {
                      backgroundColor: "",
                      color: "", // Color for odd rows
                    },
                    "& .even-row": {
                      backgroundColor: "#d0edec",
                      color: "", // Color for even rows
                    },
                  }}
                >
                  <DataGrid
                    sx={{
                      "& .MuiDataGrid-footerContainer": {
                        height: dataGridHeaderFooterHeight,
                        minHeight: dataGridHeaderFooterHeight,
                      },
                    }}
                    rowHeight={dataGridRowHeight}
                    headerHeight={dataGridHeaderFooterHeight}
                    rows={rows}
                    // rows={AttendanceEntryrow}
                    columns={AttColumn}
                    loading={exploreLoading}
                    getRowId={(row) => row.SLNO}
                    editMode="cell"
                    pageSize={pageSize}
                    page={page}
                    onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                    onPageChange={(newPage) => setPage(newPage)}
                    disableSelectionOnClick
                    onRowModesModelChange={handleRowModesModelChange}
                    onRowEditStop={handleRowEditStop}
                    processRowUpdate={processRowUpdate}
                    experimentalFeatures={{ newEditingApi: true }}
                    onProcessRowUpdateError={(error) => {
                      console.error(
                        "Row update validation failed:",
                        error.message
                      );

                      // toast.error(error.message);
                    }}
                    components={{
                      Toolbar: AttendanceTool,
                    }}
                    onStateChange={(stateParams) =>
                      setRowCount(stateParams.pagination.rowCount)
                    }
                    componentsProps={{
                      toolbar: { setRows, setRowModesModel },
                    }}
                    // componentsProps={{
                    //   toolbar: {
                    //     showQuickFilter: true,
                    //     quickFilterProps: { debounceMs: 500 },
                    //   },
                    // }}
                    rowsPerPageOptions={[5, 10, 20]}
                    getRowClassName={(params) =>
                      params.indexRelativeToCurrentPage % 2 === 0
                        ? "odd-row"
                        : "even-row"
                    }
                    onCellClick={(params) => { }}
                    pagination
                    isCellEditable={(params) => {
                      // Allow editing "remarks" column only if "present" is true
                      if (params.field === "Remarks") {
                        return params.row.Present == 1;
                      }

                      // Make other columns non-editable
                      return false;
                    }}
                  />
                </Box>
              </Box>
              <Box
                display="flex"
                justifyContent="space-between"
                mt="15px"
                gap="20px"
                padding={1}
              >
                <Box display="flex" flexDirection="row" padding="15px" gap={formGap}>
                  <Chip
                    icon={<ScheduleIcon color="primary" />}
                    label="Adjust Shift"
                    variant="outlined"
                  />
                </Box>
                <Box display="flex" flexDirection="row" padding="15px" gap={formGap}>
                  <LoadingButton
                    color="secondary"
                    variant="contained"
                    loading={isLoading}
                    onClick={handleSaveButtonClick}
                  >
                    Save
                  </LoadingButton>


                </Box>
              </Box>
            </form>
          )}
        </Formik>
        {/* <Box display="flex" flexDirection="row" padding="15px" gap={formGap}>
          <Chip
            icon={<ScheduleIcon color="primary" />}
            label="Adjust Shift"
            variant="outlined"
          />
         
        </Box> */}
        {/* </Box> */}
      </Paper>
      {/* <Dialog open={openShiftPopup} onClose={() => setOpenShiftPopup(false)}>
        <DialogTitle>Update Shift</DialogTitle>

        <DialogContent sx={{ width: 400 }}>

          <TextField
            fullWidth
            type="time"
            label="Shift Start Time"
            variant="standard"
            value={shiftPopupData.ShiftStartTime}
            onChange={(e) =>
              setShiftPopupData({ ...shiftPopupData, ShiftStartTime: e.target.value })
            }
            focused
            sx={{ mt: 2 }}
          />

          <TextField
            fullWidth
            type="time"
            label="Shift End Time"
            variant="standard"
            value={shiftPopupData.ShiftEndTime}
            onChange={(e) =>
              setShiftPopupData({ ...shiftPopupData, ShiftEndTime: e.target.value })
            }
            focused
            sx={{ mt: 2 }}
          />
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setOpenShiftPopup(false)}>Cancel</Button>
          <Button
            variant="contained"
            onClick={() => {
              // toast.success("Updated Successfully");
              setRows((prevRows) =>
                prevRows.map((r) =>
                  r.EmpID === deploymentData.RecordID
                    ? {
                      ...r,
                      shiftChecked: true,
                      ShiftCheck: "Y",
                      ShiftFromTime: shiftPopupData.ShiftStartTime,
                      ShiftToTime: shiftPopupData.ShiftEndTime,
                      Fromtime: shiftPopupData.ShiftStartTime,
                      Totime: shiftPopupData.ShiftEndTime,
                    }
                    : r
                )
              );

              setOpenShiftPopup(false);
            }}
          >
            Apply
          </Button>


        </DialogActions>
      </Dialog> */}
      <Dialog open={openShiftPopup} onClose={() => setOpenShiftPopup(false)}>
        <DialogTitle>Update Shift</DialogTitle>
        <DialogContent sx={{ width: 400 }}>
          <TextField
            fullWidth
            type="time"
            label="Shift Start Time"
            variant="standard"
            value={shiftPopupData.ShiftStartTime}
            onChange={(e) =>
              setShiftPopupData({ ...shiftPopupData, ShiftStartTime: e.target.value })
            }
            focused
            sx={{ mt: 2 }}
          />

          <TextField
            fullWidth
            type="time"
            label="Shift End Time"
            variant="standard"
            value={shiftPopupData.ShiftEndTime}
            onChange={(e) =>
              setShiftPopupData({ ...shiftPopupData, ShiftEndTime: e.target.value })
            }
            focused
            sx={{ mt: 2 }}
          />
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setOpenShiftPopup(false)}>Cancel</Button>
          <Button
            variant="contained"
            onClick={() => {
              // setRows((prevRows) =>
              //   prevRows.map((r) =>
              //     r.SLNO === shiftPopupData.SLNO
              //       ? {
              //         ...r,
              //         shiftChecked: true,
              //         ShiftFromTime: shiftPopupData.ShiftStartTime,
              //         ShiftToTime: shiftPopupData.ShiftEndTime,
              //         Fromtime: shiftPopupData.ShiftStartTime,
              //         Totime: shiftPopupData.ShiftEndTime,
              //       }
              //       : r
              //   )
              // );
              setRows((prevRows) =>
                prevRows.map((r) =>
                  r.SLNO === shiftPopupData.SLNO
                    ? {
                      ...r,
                      shiftChecked: true,
                      ShiftCheck: "Y",
                      ShiftFromTime: shiftPopupData.ShiftStartTime,
                      ShiftToTime: shiftPopupData.ShiftEndTime,
                      Fromtime: shiftPopupData.ShiftStartTime,
                      Totime: shiftPopupData.ShiftEndTime,
                    }
                    : r
                )
              );

              setOpenShiftPopup(false);
            }}
          >
            Apply
          </Button>

        </DialogActions>
      </Dialog>


    </React.Fragment>
  );
};

export default EditAttendanceEntry;
